import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { GlobalService } from '../services/global.service';
import { ModalService } from '../shared/modal/modal.service';
import { SnackBarService } from '../shared/snackbar/snackbar.service';
import { LoadingService } from '../shared/loading/loading.service';
import { SidebarService } from '../services/sidebar.service';

import { CostProjectionDetailsComponent } from '../shared/modal/cost-projection-details/cost-projection-details.component'
import { CostOfWaitingComponent } from '../shared/modal/cost-of-waiting/cost-of-waiting.component'
import { FundingSourceComponent } from '../shared/modal/funding-source/funding-source.component';
import { AdjustRatesComponent } from '../shared/modal/adjust-rates-of-return/adjust-rates.component';
import { RiskTolWizardComponent } from '../shared/modal/risk-tol-wizard/risk-tol-wizard.component';
import { RiskRolAdvisorAgreementComponent } from '../shared/modal/risk-rol-advisor-agreement/risk-rol-advisor-agreement.component';

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import Utils from '../shared/utility';

import { investmentGrowthDecumation } from '../dummy-data/data';

@Component({
  selector: 'app-long-term-care',
  templateUrl: './long-term-care.component.html',
  styleUrls: ['./long-term-care.component.css']
})
export class LongTermCareComponent implements OnInit {
  isAlreadyInitializeComponent: boolean = false;
  preRetirementColor: any;
  annulLTCColor: any;
  inRetirementColor: any;
  ltcReport;
  user;

  constructor(public sidebarService: SidebarService, public globalService: GlobalService, public modalService: ModalService, public snackBarService: SnackBarService, public router: Router, public loadingService: LoadingService, public dialog: MatDialog) {
    this.preRetirementColor = this.barVerticalStackedChartOption.colorScheme.domain[0];
    this.annulLTCColor = this.barVerticalStackedChartOption.colorScheme.domain[1];
    this.inRetirementColor = this.barVerticalStackedChartOption.colorScheme.domain[2];
    this.globalService.featFunding = JSON.parse(localStorage.getItem('featFunding'));
    this.globalService.featRiskTolerance = JSON.parse(localStorage.getItem('featRiskTolerance'));
    //this.globalService.featRiskTolerance = true;

    Object.assign(this, { investmentGrowthDecumation });
    this.imgSrc = '../../../assets/icons/long_term_care_illustration_orange.svg';
    this.isSrcReport = "lTCReport";
    this.additionalFunds = 0;
    this.selected.isoneTimeInvestmentSelect = true;
    this.totalOutOfPocket = 5000;
    this.totalSocialSecurity = 2000; 
    modalService.modal$.subscribe((modal) => {
      // console.log("Subscriptiong from : /reports/create/ltc");
      // TODO: Fix this hack -- naming it hidden.. modals in general need to be refactored
      if (modal.modalName == 'add-edit-clientClosed') {
        this.getClient();
      }
    });

    //required for page refresh when updating client profile
    this.router.routeReuseStrategy.shouldReuseRoute = () => {
      return false;
    };

    sidebarService.clientUpdated.subscribe(()=>{
      if (this.isAlreadyInitializeComponent) {
        console.log('sidenav adj');
        this.router.navigate(['/clients/edit/long-term-care/options/ltc']);
      }
    });

    if(this.globalService.featRiskTolerance){
      this.router.events
            .filter(event => event instanceof NavigationEnd)
            .subscribe(event => this.handleRiskTolCheck((event as NavigationEnd).url));
    }
  }

  @ViewChild('p1Percent') p1Percent: ElementRef;
  @ViewChild('p1EndAge') p1EndAge: ElementRef;
  @ViewChild('p2Percent') p2Percent: ElementRef;
  @ViewChild('p2EndAge') p2EndAge: ElementRef;
  @ViewChild('p3Percent') p3Percent: ElementRef;
  @ViewChild('annualEl') annualEl: ElementRef;
  
  public pocMessage: string = "The length, in years, that the client will require long-term care services.";
  public mrMessage: string =  "Costs can vary within each state, so selecting the metro area will provide a more accurate expense projection.";
  public loaMessage: string =  "Skilled Nursing: Retirement community with professionals providing help with Activities of Daily Living (ADLs) on a regular basis. Assisted Living: Retirement community but with more individual freedom and less reliance on assistance. Home Healthcare: Professionals administer care in the client’s home.";
  public fsMessage: string = "Select up to three unique rates of return throughout the client’s lifetime to produce multiple savings solutions for unfounded future health expenses: a one time investment, annual payments, or weekly payments.";
 
  public tptMessage: string =  "Projected lifetime household cost for long-term care needs, after incorporating a 3% annual inflation adjustment so as to show costs in the net present value.";
  public tpfMessage: string =  "One-time investment value required today, based on rates of return indicated below, to fund household lifetime LTC needs.";
  //old: public tpfMessage: string =  "Projected lifetime household cost for long-term care needs, show in the future value.";

  public eacMessage: string = "Current annual cost for the select care setting this year (this will not be your actual cost).";
  //old: public eacMessage: string =  "Projected lifetime household cost for long-term care needs, show in the future value.";
  public pacMessage: string =  "One year of cost in the year that long-term care is first needed, according to projections.";
  public tpcMessage: string =  "Total cost of long-term care that is needed, according to projections. Note that this may cover more (or less) than one year of coverage, according to the selection made for Period of Care.";
  public naMessage: string = "";
  
  public error: any;
  public client: any;
  public partnerActive: boolean;
  public investmentOptionValue: 0;

  public fundingItems: any[] = [];
  public totalRemainingGap: number = 0;
  public beginningBalance: number;

  public response: any = {};

  public clientRegions: any;
  public spouseRegions: any;

  //[(ngModel)]="clientClaimStatus"

  public selfPeriods: number = 12;
  public selfRegion: number = 0;
  public selfType: number = 1;
  public selfTypeList: any[] = [{ careType: 1, lengthOfCare: 12 }];

  public spousePeriods: number = 12;
  public spouseRegion: number = 0;
  public spouseType: number = 1;
  public spouseTypeList: any[] = [{ careType: 1, lengthOfCare: 12 }];


  public pieChartData: any[];
  public barChartData: any[];

  public lineChartOptions = {
    showXAxis: true,
    showYAxis: true,
    gradient: false,
    showLegend: true,
    xAxisLabel: '',
    yAxisLabel: '',
    roundDomains: true,
    colorScheme: {
      domain: ['#bad052', '#bad052', '#bad052']
    },
    autoScale: true
  }

  public pieChartOptions = {
    showLegend: false,
    colorScheme: { domain: ['#bad054','#eaf0cb', '#e3ecba', '#dce7a9', '#d5e298', '#cede87', '#c7d976', '#c0d465'] },
    showLabels: false,
    explodeSlices: false,
    doughnut: false,
    view: [500, 250],
    autoScale: true
  }

  public barChartOptions = {
    showXAxis: true,
    showYAxis: true,
    gradient: false,
    showLegend: false,
    showXAxisLabel: false,
    xAxisLabel: 'Country',
    showYAxisLabel: false,
    roundEdges: false,
    yAxisLabel: 'Population',
    
    colorScheme: {
      domain: ['#e8f0c7', '#d3e08e', '#bad054']
    }
  }

  public barVerticalStackedChartOption = {
    showXAxis: true,
    showYAxis: true,
    gradient: false,
    showLegend: false,
    showXAxisLabel: false,

    showYAxisLabel: false,

    roundEdges: false,
    colorScheme: {
      // domain: ['#5270ad', '#487879', '#63a49e']
      domain: ['#63a49e', '#5270ad','#487879']
      
    },
    autoScale: true

  };

  currentYear = new Date().getFullYear();


  public fundingSource: any;
  public startAge: any;
  public endAge: any;
  public inflationRate: any;
  public annContribution: any;
  showFundingBorder: boolean;
  showStartAgeBorder: boolean;
  showEndAgeBorder: boolean;
  showInflationBorder: boolean;
  showAnnContrBorder: boolean;

  showTable: boolean;

  imgSrc: string;
  isSrcReport: string;
  futureTotalCost: number;
  additionalFunds: number;
  currentRemainingTotal: number;
  annuallyWeeklyTtlYear: number;
  investmentGrowthDecumation: any[];
  yearlyCost: number;
  weeklyCost: number;
  adjustedYearlyCost: number = null;
  adjustedWeeklyCost: number = null;
  totalOutOfPocket: number;
  totalSocialSecurity: number;
  dropDownSelectedIndexAnnually: number = 0;
  dropDownSelectedIndexWeekly: number = 0;
  investmentDescription: string;
  bodyCardSelectedIndexAnnually: number;
  bodyCardSelectedIndexWeekly: number;

  public selected: any = {
    isoneTimeInvestmentSelect: false,
    isannuallyRecurringInvestmentSelect: false,
    isweeklyRecurringInvestmentSelect: false,
  }

  isReturenedAdjustedData: boolean = false;

  equitiesLargeCap;
  equitiesMidCap;
  equitiesSmallCap;
  equitiesInternational;
  equitiesReturn;
  fixedGovBonds;
  fixedCorpBonds;
  fixedReturn;
  cashMoneyMarket;
  cashMoneyMarketReturn;
  hasRiskTolBeenRan: boolean = false;
  currentRemainingTotalForRiskTolPort;
  portfolioRecommendationVisible: boolean = false
  portfolioRecommendationObject;
  isAlreadyRetired: boolean = false;
  isHCIllustration:boolean = true;
  rorPhaseOneYear;
  isRetired: boolean;

  objAdjustRates;
  objRiskTolerance;
  objRickToleranceAccountAgreement;

  @ViewChild('FundingSource') fundingSourceInput:any;
  @ViewChild('AnnContribution') annContributionInput:any;
  @ViewChild('StartAge') startAgeInput:any;
  @ViewChild('EndAge') endAgeInput:any;
  @ViewChild('InflationRate') inflationRateInput:any;

  ngOnInit() {
    this.isAlreadyInitializeComponent = true;
    this.loadingService.isLoading(true);
    this.getClient();
    
  }
  
  reDirectModal(modalName): void {
    /* if (modalName == 'costExplained') {
      const dialogRef = this.dialog.open(CostProjectionDetailsComponent, {
        //width: '1000px',
        //height: '700px',
        data: {hcDataV2: this.response, partnerActive: this.partnerActive, FrmPV: this.FrmPV }
      });
    } */
    if (modalName == 'costOfWaiting') {
      const dialogRef = this.dialog.open(CostOfWaitingComponent, {
        //width: '1000px',
        //height: '700px',
        data: {hcDataV2: this.response }
      });
    }
    if (modalName == 'adjustRates') {
      const dialogRef = this.dialog.open(AdjustRatesComponent, {
       /*  width: '1000px',
        height: '700px', */
        data: {client: this.client, obj: this.objAdjustRates, modalName: modalName }
      });

      //on close
      dialogRef.afterClosed().subscribe(result =>{
        //recalc illustration page here with new ROR values
        //console.log('from close', result);
        if(result){
          this.objAdjustRates = result;
          if(this.isRiskModalDisplayed){
            this.portfolioRecommendationObject.phase1Val = this.objAdjustRates.rorOne;
            this.portfolioRecommendationObject.phase2Val = this.objAdjustRates.rorTwo;
            this.hasRiskTolBeenRan = false;

            this.getPortfolioRecommendation();
          } else {
            this.getLTCData(this.client);
          }
        }
      });
    }

    if(modalName == 'riskTolerance' && this.globalService.featRiskTolerance){
      this.isRiskModalDisplayed = true;

      var body = {
        ClientID: Number(localStorage.getItem("selectedClient"))
      };
      
      this.globalService.getClientRiskTolerance(body)
      .subscribe(
        risk => {     
          //console.log('from server', risk); 
          var riskResponse;
          if(risk != null){   
            riskResponse = risk;
          }

          const dialogRef = this.dialog.open(RiskTolWizardComponent, {
            data: {client: this.client, obj: riskResponse, modalName: modalName }
          });

          //on close
          dialogRef.afterClosed().subscribe(result =>{        
            if(result){
              this.objRiskTolerance = result;
              //this.getHCData(this.client, this.partnerActive);
              this.saveClientRiskTol(false);
            }
          });
        });  
    }

    if(modalName == 'riskToleranceAdvisorAgreement' && this.globalService.featRiskTolerance){
      const dialogRef = this.dialog.open(RiskRolAdvisorAgreementComponent, {
        data: {client: this.client, obj: '', modalName: modalName }
      });

      //on close
      dialogRef.afterClosed().subscribe(result =>{        
        if(result){
          this.objRickToleranceAccountAgreement = result;
          this.saveClientRiskTol(true);
        }
      });
    }

  }

  public clientYearsOfStay: number = 5;
  public spouseYearsOfStay: number = 5;

  getClient() {
    console.log('get Client data');
    this.globalService.getClientData(Number(localStorage.getItem("selectedClient")), 4)
      .subscribe(
      client => {
        this.client = client;
        this.client.clientProfile.Spouses = JSON.parse(this.client.clientProfile.Spouses);
        if (this.client.clientProfile.Spouses.length && this.client.clientProfile.Spouses[0].maritalStatus == 'Married') {
          this.partnerActive = true;
          this.spouseYearsOfStay = Math.min(15, this.client.clientProfile.Spouses[0].LifeExpectancy - this.calculateAge(this.client.clientProfile.Spouses[0].dob));
        } else {
          this.partnerActive = false;
        }
        this.calculatAnnualWeeklyTtlYear();
        // let dOB = new Date(this.client.client.DOB);
        // let timeDiff = Math.abs(Date.now() - dOB.getTime());
        // let clientAge = Math.floor((timeDiff / (1000 * 3600 * 24))/365.25);
        // let retirementAge = this.client.clientProfile.RetirementAge;
        // if (clientAge > retirementAge) {
        //   let dropDownSelectedIndex = 3;
        //   let clientLifeExpectance = this.client.clientProfile.LifeExpectancy;
        //   if (this.partnerActive) {
        //     let spouseLifeExpectancy = this.client.clientProfile.Spouses[0].LifeExpectancy;
        //     let spouseAge = Number(this.globalService.calculateAge(client.clientProfile.Spouses[0].dob));
        //     let spouseLifeRemainingYr = spouseLifeExpectancy - spouseAge;
        //     let clientLifeRemainingYr = clientLifeExpectance - clientAge;
        //     if (spouseLifeRemainingYr < clientLifeRemainingYr) {
        //       this.annuallyWeeklyTtlYear = spouseLifeExpectancy - (spouseAge + 5);
        //         if (this.annuallyWeeklyTtlYear < 0) {
        //           this.annuallyWeeklyTtlYear = spouseLifeExpectancy - spouseAge;
        //         }
        //     } else {
        //       this.annuallyWeeklyTtlYear = clientLifeExpectance - (clientAge + 5);
        //       if (this.annuallyWeeklyTtlYear < 0) {
        //         this.annuallyWeeklyTtlYear = clientLifeExpectance - clientAge;
        //       }
        //     }

        //   } else {
        //     this.annuallyWeeklyTtlYear = clientLifeExpectance - (clientAge + 5);
        //     if (this.annuallyWeeklyTtlYear < 0) {
        //       this.annuallyWeeklyTtlYear = clientLifeExpectance - clientAge;
        //     }
        //   }
        //   if (this.annuallyWeeklyTtlYear == 0) {
        //     dropDownSelectedIndex = 0;
        //   } else if (this.annuallyWeeklyTtlYear < 3) {
        //     dropDownSelectedIndex = 1;
        //   }
        //   this.dropDownSelectedIndexWeekly = this.dropDownSelectedIndexAnnually = dropDownSelectedIndex;
        // } else {
        //   this.annuallyWeeklyTtlYear = ((retirementAge - clientAge) > 1) ? retirementAge - clientAge : 1;
        // }
        console.log('annuallyWeeklyTtlYear', this.annuallyWeeklyTtlYear);
        this.clientYearsOfStay = Math.min(15, this.client.clientProfile.LifeExpectancy - this.calculateAge(this.client.client.DOB));
        
        if (this.client.clientProfile.Spouses.length > 1) {
          this.client.clientProfile.Spouses = Utils.calculateMostProfitableSpouse(this.client, this.client.clientProfile.Spouses);
        }

        this.client.clientProfile.Children = JSON.parse(this.client.clientProfile.Children);
        // console.log(this.client);

        //display Risk Tol modal
        if(this.isRiskModalDisplayed){
          this.reDirectModal('riskTolerance');
        }

        this.getLTCData(client);
      },
      error => this.error = <any>error);
  }

  calculatAnnualWeeklyTtlYear() {
    const today = new Date();
    const currentMonth = today.getMonth();
    const currentDay = today.getDate();
    const currentYear = today.getFullYear();
    let dOB = new Date(this.client.client.DOB);
    let birthMonth = dOB.getMonth();
    let birthDay = dOB.getDate();
    let timeDiff = Math.abs(Date.now() - dOB.getTime());
    let clientAge = Math.floor((timeDiff / (1000 * 3600 * 24))/365.25);
    let retirementAge = this.client.clientProfile.RetirementAge;
    let clientLifeExpectancy = this.client.clientProfile.LifeExpectancy;
    // let clientLifeRemainingYr = currentMonth > birthMonth || (currentMonth === birthMonth && currentDay >= birthDay) ? clientLifeExpectancy - clientAge : clientLifeExpectancy - clientAge - 1;
    this.annuallyWeeklyTtlYear = this.startingLTCYear - currentYear;
    console.log('this.startingLTCYear', this.startingLTCYear);
    if (this.partnerActive) {
      let spouseDOB = new Date(this.client.clientProfile.Spouses[0].dob);
      birthMonth = spouseDOB.getMonth();
      birthDay = spouseDOB.getDate();
      let spouseLifeExpectancy = this.client.clientProfile.Spouses[0].LifeExpectancy;
      let spouseAge = Number(this.globalService.calculateAge(this.client.clientProfile.Spouses[0].dob));
      let spouseLifeRemainingYr = currentMonth > birthMonth || (currentMonth === birthMonth && currentDay >= birthDay) ? spouseLifeExpectancy - spouseAge : spouseLifeExpectancy - spouseAge - 1;
      console.log(currentMonth > birthMonth || (currentMonth === birthMonth && currentDay >= birthDay));
      console.log('spouseLifeRemainingYr', spouseLifeRemainingYr);
    }
  }

  returnedFundingSource(data){
    console.log('retured data to LTC page', data);   
    this.contributionAmount = 0; 
    this.fundingItems = [];
    if(data.length > 0)
    {      
      for (var item in data){    
        this.contributionAmount += data[item].totalContribution; 
        this.handleNewFundingItem(data[item].fundingSource, data[item].annualContribution, 
          data[item].startYear, data[item].endYear, data[item].inflationRate);
      }
    } else {
      this.getLTCData(this.client, this.isRiskModalDisplayed);
    }

  }
  
  selectedTab = 2;
  returnedAdjustedLongTermCare(data){
    console.log('retured Adjusted data to LTC page', data);
    this.isReturenedAdjustedData = true;
    //this.selectedTab = data.selectedTab;
    
    //TODO: you can use the below to TEST - but the API needs to be changed to allow for this new functionality to work properly
    //right now, we only allow one care setting, we need to adjust to allow for as many as passed back from dialog/modal
    this.selfType = data.client[0].careType;
    this.selfTypeList = data.client;
    this.selfPeriods = data.client[0].lengthOfCare;
    if(data.spouse.length > 0){
      this.spouseType = data.spouse[0].careType;
      this.spouseTypeList = data.spouse;
      this.spousePeriods = data.spouse[0].lengthOfCare;
    }
    
    this.getLTCData(this.client, this.isRiskModalDisplayed);    
  }

  addFunds: boolean;
  contributionAmount;
  handleNewFundingItem(fundingSource: string, annContribution: number, startAge: number, endAge: number, inflationRate: number) {
    
    this.addFunds = true;

    if(startAge < this.currentYear){
      startAge = this.currentYear;
    }

    if(endAge < startAge || endAge > (this.client.clientProfile.LifeExpectancy - this.calculateAge(this.client.client.DOB)) + this.currentYear){
      endAge = (this.client.clientProfile.LifeExpectancy - this.calculateAge(this.client.client.DOB)) + this.currentYear;
    }
   
    annContribution = Utils.formatToNumber(annContribution)
    //this.contributionAmount = this.getFutureContributionAmountV2(annContribution, endAge - startAge, inflationRate, startAge, null);
    
    this.totalRemainingGap = this.formatNumber((this.totalRemainingGap - Number(this.contributionAmount)));
    let isFundingItemPush = true;
    console.log('this.fundingItems', this.fundingItems);
    if (this.fundingItems.length > 0) {
      this.fundingItems.forEach(item => {
        console.log(item);
        if (item.fundingSource == fundingSource && item.annContribution == annContribution && item.startAge == startAge && item.endAge == endAge && item.inflationRate == inflationRate && item.contributionAmount == this.formatNumber(this.contributionAmount)) {
          isFundingItemPush = false;
        }
       })
    }

   if (isFundingItemPush) {
    this.fundingItems.push({
      fundingSource,
      annContribution,
      startAge,
      endAge,
      inflationRate,
      contributionAmount: this.formatNumber(this.contributionAmount),
      remainingUnfunded: this.formatNumber(this.totalRemainingGap)
    });
   }


    /* this.fundingSourceInput.nativeElement.value = '';
    this.annContributionInput.nativeElement.value = '';
    this.startAgeInput.nativeElement.value = '';
    this.endAgeInput.nativeElement.value = '';
    this.inflationRateInput.nativeElement.value = ''; */
    
    this.getLTCData(this.client, this.isRiskModalDisplayed);
  }

  ltcData;

  costOfWaitingModal(modalName): void {
    const dialogRef = this.dialog.open(CostOfWaitingComponent, {
      width: '1000px',
      height: '700px',
      data: { response: this.response, modalName: modalName }
    });
  }

  generatePieChartData() {
    var tempTotal = Utils.formatToNumber(this.totalRemainingGap); // -  this.futureTotalCost - (this.hcDataV2.FundingOptions.PartB.replace(/,/g,"").replace("$",""));
    

    if (this.fundingItems.length) {
      tempTotal = this.fundingItems[this.fundingItems.length - 1].remainingUnfunded;
    }

    // tempTotal = tempTotal - this.fundingItems.reduce((acc, item, i) => { 
    //   console.log(item, acc, i);
    //   return acc + item.remainingUnfunded
    // }, 0);
    
    this.pieChartData = [
      { "name": "Unfunded", "value": tempTotal }
    ]

    this.fundingItems.forEach((item) => { this.pieChartData.push({ "name": item.fundingSource, "value": item.contributionAmount })});
  }

  public expectedLE: any;
  public startingLTCYear: any;

  currentLTCObject;
  getLTCData(client, useRiskTolSingleInvestment?: any) {
    const isMarried = client.clientProfile.Spouses[0] && client.clientProfile.Spouses[0].maritalStatus == 'Married' ? true : false;

    var investmentItems = [];
    var currentAge = this.calculateAge(client.client.DOB);
    var currentYear = new Date().getFullYear();

    for (var item in this.fundingItems) {

      /* var contribution = {
        Description: this.fundingItems[item].fundingSource,
        Begins: (this.fundingItems[item].startAge - currentAge) + currentYear,
        StartAmount: this.fundingItems[item].annContribution,
        Ends: (this.fundingItems[item].endAge - currentAge) + currentYear,
        Cola: this.fundingItems[item].inflationRate,
      } */

      var contribution = {
        Description: this.fundingItems[item].fundingSource,
        Begins: this.fundingItems[item].startAge,
        Ends: this.fundingItems[item].endAge,
        StartAmount: this.fundingItems[item].annContribution,
        Cola: this.fundingItems[item].inflationRate,
      }

      investmentItems.push(contribution);
    }

    this.selfRegion = parseInt(client.clientProfile.ClientMetroArea || 0);
    if(isMarried){
      this.spouseRegion = parseInt(client.clientProfile.SpouseMetroArea || 0);
    }

    let spouseDOB = this.client.clientProfile.Spouses[0].dobStr ? this.client.clientProfile.Spouses[0].dobStr : (new Date(this.client.clientProfile.Spouses[0].dob) ? this.client.clientProfile.Spouses[0].dob : '');

    const ltc = {
      investmentItems: JSON.stringify({ investmentItems }),
      FrmHasPartner: isMarried,
      FrmName0: client.client.FirstName + ' ' + client.client.LastName,
      FrmName1: isMarried ? client.clientProfile.Spouses[0].firstName + ' ' + client.clientProfile.Spouses[0].lastName : '',
      FrmGender0: client.client.GenderID,
      FrmCurrentAge0: this.calculateAge(client.client.DOB),
      FrmGender1: isMarried ? Number(client.clientProfile.Spouses[0].gender) : 0,
      FrmCurrentAge1: isMarried ? this.calculateAge(client.clientProfile.Spouses[0].dob) : 0,
      FrmLTCState0: client.clientProfile.UseNationalAverage ? '' : client.clientProfile.RetirementState,
      FrmHealth0: 0,
      FrmHealth1: 0,
      FrmLTCState1: isMarried ? (client.clientProfile.UseNationalAverage ? '' : this.client.clientProfile.Spouses[0].state) : '',

     /*  FrmPhase1Rate: (this.p1Percent ? (Number(this.p1Percent.nativeElement.value)) : 6),
      FrmPhase1Periods: (this.p1EndAge ? Number(this.p1EndAge.nativeElement.value) - this.calculateAge(this.client.client.DOB) : Math.max(65 - Number(this.calculateAge(this.client.client.DOB)))),
      FrmPhase2Rate: (this.p2Percent ? (Number(this.p2Percent.nativeElement.value)) : 6),
      FrmPhase2Periods: (this.p2EndAge ? (Number(this.p2EndAge.nativeElement.value) - (Number(this.p1EndAge.nativeElement.value))) : 10),
      FrmPhase3Rate: (this.p3Percent ? (Number(this.p3Percent.nativeElement.value)) : 6), */
      FrmPhase1Rate: this.objAdjustRates ? (Number(this.objAdjustRates.rorOne)) : 6,
      FrmPhase1Periods: this.objAdjustRates ? Number(this.objAdjustRates.throughYearOne) : Math.max(65 - Number(this.calculateAge(this.client.client.DOB))),
      FrmPhase2Rate: this.objAdjustRates ? (Number(this.objAdjustRates.rorTwo)) : 6,
      FrmPhase2Periods: this.objAdjustRates ? (Number(this.objAdjustRates.throughYearTwo)) : 10,
      FrmPhase3Rate: this.objAdjustRates ? (Number(this.objAdjustRates.rorThree)) : 6,
      
      FrmPlanningAge0: this.client.clientProfile.LifeExpectancy,
      FrmPlanningAge1: isMarried ? Number(this.client.clientProfile.Spouses[0].LifeExpectancy) : 0,

      MetroRegion0: this.selfRegion, // here
      MetroRegion1: this.spouseRegion,

      //InvestmentYears: this.annualEl && this.annualEl.nativeElement ? this.annualEl.nativeElement.value : (this.annuallyWeeklyTtlYear < 10 ? 1 : 10),
      InvestmentYears: (this.investmentOption == 1) ? this.annualEl && this.annualEl.nativeElement ? this.annualEl.nativeElement.value : (this.annuallyWeeklyTtlYear < 10 ? 1 : 10) 
        : (this.investmentOption == 2) ? this.bodyCardSelectedIndexAnnually : this.bodyCardSelectedIndexWeekly,
      InvestmentOption: this.investmentOption,

      //TODO: can probable remove once the fields below are working in API
      CareType: this.selfType,
      CareType1: this.spouseType,
      FrmLTCMonths0: this.selfPeriods,
      FrmLTCMonths1: this.spousePeriods,

      //these lists have both type and periods/length of time
      ClientCareTypes: this.selfTypeList,
      SpouseCareTypes: this.spouseTypeList,
      SelfDOB: this.client.client.DOB,
      SpouseDOB: spouseDOB,
    }

    if(this.globalService.featRiskTolerance && useRiskTolSingleInvestment){
      ltc.FrmPhase1Rate = (this.objAdjustRates) ? this.objAdjustRates.rorOne : (this.portfolioRecommendationObject.phase1Val ? Number(this.portfolioRecommendationObject.phase1Val):0);
      ltc.FrmPhase1Periods = ((this.objAdjustRates) ? this.objAdjustRates.throughYearOne - this.currentYear : this.getPhaseAgeDiffLTC(1));
      ltc.FrmPhase2Rate = (this.objAdjustRates) ? this.objAdjustRates.rorTwo : (this.portfolioRecommendationObject.phase2Val ? Number(this.portfolioRecommendationObject.phase2Val):0);
      ltc.FrmPhase2Periods = ((this.objAdjustRates) ? this.objAdjustRates.throughYearTwo - this.objAdjustRates.throughYearOne : this.getPhaseAgeDiffLTC(2));
      ltc.FrmPhase3Rate = (this.objAdjustRates) ? this.objAdjustRates.rorThree : (this.portfolioRecommendationObject.phase2Val ? Number(this.portfolioRecommendationObject.phase2Val):0);

      if (this.isAlreadyRetired) {
        ltc.FrmPhase2Rate = ltc.FrmPhase1Rate;
        ltc.FrmPhase2Periods = Number(this.client.clientProfile.LifeExpectancy) - Number(this.client.clientProfile.RetirementAge);
        ltc.FrmPhase3Rate = ltc.FrmPhase1Rate;
      }
    }

    this.ltcReport = ltc;

    const isReturenedAdjustedData = {
      isReturenedAdjustedData: this.isReturenedAdjustedData
    }

    console.log(ltc);
    // this.currentLTCObject = ltc;
    this.currentLTCObject = Object.assign(ltc, isReturenedAdjustedData);
    this.currentLTCObject.selectedTab = this.selectedTab;

    //const isMarried = this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? true : false;

    const queryInfo = {
      clientID: client.client.ID,
      userID: client.client.AdvisorID,
      orgID: client.client.OrganizationID,
      clientRetirementAge: client.clientProfile.RetirementAge,
      partnerRetirementAge: isMarried ? this.client.clientProfile.Spouses[0].retirementAge : 0
    }
    
    this.user = queryInfo;

    console.log('ltc request', ltc);
    this.globalService.getLTCData(ltc, queryInfo)
      .subscribe(
        data => {
          this.response = data;          
          this.futureTotalCost =  this.response.LTCGrandTotAmt ? Utils.removeCurrencyFormatting(this.response.LTCGrandTotAmt.replace(',','')) : 0;
          console.log(this.futureTotalCost);
          this.currentRemainingTotal = this.futureTotalCost - this.additionalFunds;
          if(this.addFunds){
            //if in here, Additional Funds were added
            this.currentRemainingTotal = this.formatNumber((this.currentRemainingTotal - Number(this.contributionAmount) > 0) ? (this.currentRemainingTotal - Number(this.contributionAmount)) : 0);
          }

          console.log("LTC data", this.response);
          // console.log('LTC DATA:', data.IllustrationBody);
          /*  for (let entry of this.response.IllustrationBody) {
             if(entry.)
           } */

          this.totalRemainingGap = Utils.formatToNumber(this.response.depositedToday.toFixed(0));
          this.beginningBalance = this.response.initialInvestment;
          if(this.globalService.featRiskTolerance && useRiskTolSingleInvestment){
            this.portfolioRecommendationObject.singleInvestment = this.totalRemainingGap;
          }

          this.response.depositedToday = Utils.formatToCurrency(this.response.depositedToday.toFixed(0));
          // this.response.annualNumber = Utils.formatToCurrency(this.response.annualNumber.toFixed(0));
          this.yearlyCost = this.response.annualNumber ? this.response.annualNumber.toFixed(0) : 0;
          console.log('yearlyCost', this.yearlyCost);
          this.futureYearlyCost = Number(this.yearlyCost) * (this.annuallyWeeklyTtlYear >= 10 ? 10: this.annuallyWeeklyTtlYear);
          console.log('futureYearlyCost', this.futureYearlyCost);
          // this.futureYearlyCost =  this.response.annualNumber * this.annualEl.nativeElement.val();
          // this.response.weeklyNumber = Utils.formatToCurrency(this.response.weeklyNumber.toFixed(0));
          this.weeklyCost = this.response.weeklyNumber?this.response.weeklyNumber.toFixed(0): 0;
          this.futureWeeklyCost  = Number(this.weeklyCost) * 52 * ((this.annuallyWeeklyTtlYear >= 10 ? 10: this.annuallyWeeklyTtlYear))
          // this.futureWeeklyCost = (this.response.weeklyNumber) * 52 * this.annualEl.nativeElement.val();
          this.response.totalFutureNumber = Utils.formatToCurrency(this.response.totalFutureNumber.toFixed(0));
          console.log('weeklyCost', this.weeklyCost);

          this.clientRegions = this.response.regionExpenses.Rows.splice(1, this.response.regionExpenses.Rows.length);
          this.spouseRegions = isMarried ? this.response.regionExpenses1.Rows.splice(1, this.response.regionExpenses1.Rows.length) : [];

          this.client && this.client.clientProfile ? this.client.clientProfile.LifeExpectancy : '--'
          this.startingLTCYear = data.LTCYear1 ? Math.min(data.LTCYear, data.LTCYear1) : data.LTCYear;

          this.expectedLE = this.client.clientProfile.LifeExpectancy;

          if (isMarried) {
            this.expectedLE = this.client.clientProfile.LifeExpectancy > this.client.clientProfile.Spouses[0].LifeExpectancy ? this.client.clientProfile.LifeExpectancy : this.client.clientProfile.Spouses[0].LifeExpectancy;
          }

          //this.futureYearlyCost =  Utils.formatToCurrency(this.response.annualNumber * this.annualEl.nativeElement.val());
          //(this.response.annualNumber * 10)

          this.generatePieChartData();
          this.generateBarChartData();

          this.getInvestmentGrowthData();
          this.calculatAnnualWeeklyTtlYear();

          this.loadingService.isLoading(false);
        },
        error => this.error = <any>error);

  }

  
  formatDataLabel(value, model)
  {
    let projectedYear;
    // console.log('ltc model', model);
    //console.log('ltc investmentGrowthData', this.investmentGrowthData);
    if (this.investmentGrowthData) {
      for (var i = 0; i < this.investmentGrowthData.length; i++) {
        // console.log('this.projectedYears[i].Year', this.investmentGrowthData[i].Year)
        // console.log('i', i)
        if (Number(this.investmentGrowthData[i].name) == Number(model.series)) {
          projectedYear = this.investmentGrowthData[i];
        }
      }
    }

    //console.log('projectedYear', projectedYear);
    if (projectedYear && projectedYear.series.length > 0) {

      //HACK
      //projectedYear = projectedYear.map(p => p.name == 'Annual Healthcare Spend' ? 'Annual LTC Spend' : 'Annual Healthcare Spend');
      /* for(var i = 0; i < projectedYear.series.length; i++){
        if(projectedYear.series[i].name == 'Annual Healthcare Spend'){
          projectedYear.series[i].name = 'Annual LTC Spend';
          model.label = 'Annual LTC Spend';
        }
      } */

      // let investmentValue = Number(projectedYear.series.find(x => x.name == 'Investment Value, In Retirement').value);
      // console.log('investmentValue', investmentValue)

      // console.log('annualHCValue', annualHCValue);
      // console.log('value', value);
      // if (investmentValue > annualHCValue) {
      //   if(model && model.label == "Investment Value, In Retirement") {
      //     return Utils.formatToCurrency(Math.round(value + Utils.formatToNumber(annualHCValue)));
      //   }
      // } else if(model && model.label == "Annual Healthcare Spend") {
      //     return Utils.formatToCurrency(Math.round(value + Utils.formatToNumber(investmentValue)));
      // }
      if(model && model.label == "Investment Value, In Retirement") {
        let annualHCValue = Number(projectedYear.series.find(x => x.name == 'Annual Healthcare Spend').value);
        return Utils.formatToCurrency(Math.round(value + Utils.formatToNumber(annualHCValue)));
      }
    }
    // console.log('value', value);
    return Utils.formatToCurrency(Math.round(Utils.formatToNumber(value)));
  }

  public futureYearlyCost: any = 0;
  
  public futureWeeklyCost: any = 0;

  handleEditClientModal(e) {
    this.modalService.add('add-edit-client', { ID: this.client.client.ID });
  }

  removeFundingItem(item) {
    this.fundingItems.splice(this.fundingItems.indexOf(item), 1);
    this.onRateChange(0);
    this.fundingTableCount();
  }

  onRateChange(percentValue) {

    //get HC data
    //this.getHCData(this.client, this.partnerActive);
   
    if (percentValue != undefined) {
      if (percentValue.value > 12) {
        return percentValue.value = 12;
      }
    }
  }

  getFutureContributionAmountV2(startAmount, years, inflation, startAge, idx) {
    var result = 0;

    for (let i = 0; i < years + 1; i++) {
      result = result + (startAmount * Math.pow((1 + inflation / 100), i));
    }

    return result;
  }

  formatNumber(amount) {
    return Math.round(amount);
  }


  /* calculateAge(birthday) {
    birthday = new Date(birthday);
    var ageDifMs = Date.now() - birthday;
    var ageDate = new Date(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  } */

  calculateAge(birthday) {
    var bday = new Date(birthday);
    var today = new Date();
    return today.getFullYear() - bday.getFullYear();
  }

  calcAnnualSavings(el, el2) {
    el2.value = el.value;
    this.getLTCData(this.client);
  }

  calcWeeklySavings(el) {
    // el.value = el2.value;
    this.getLTCData(this.client);
  }

  getRetirementYear(retirementAge, dob) {
    var currentAge = this.calculateAge(dob);
    var diff = retirementAge - currentAge;
    var year = new Date().getFullYear();
    return year + diff;
  }

  handleIllustrationModal(e) {


    // var projectedYears = this.hcDataV2.Illustrations.map(entry => {
    //   return {
    //     Year: 2018,
    //     BeginningBalance: '$' + (entry.BeginningBalance ? entry.BeginningBalance.toFixed(0) : 0),
    //     ExpectedRateReturn: (entry.CashFlowEntry.ExpectedRor ? entry.CashFlowEntry.ExpectedRor * 100 + '%': 0),
    //     Premiums: '$' + 0,
    //     Contribution: '$' + (entry.CashFlowEntry.TotalIncome ? entry.CashFlowEntry.TotalIncome.toFixed(0) : 0),
    //     AdditionalCosts: '$' + 0,
    //     Total: '$' + (entry.CashFlowEntry.Expense ? entry.CashFlowEntry.Expense.toFixed(0) : 0),
    //     NetOfSSDeductions: '$' + 0,
    //     EngingBalance: '$' + (entry.EndingBalance ? entry.EndingBalance.toFixed(0) : 0),
    //   }
    // });

    this.modalService.add('ltc-projections', { Data: this.response.IllustrationBody });
  }

  public cowValues: any = {
    one: 0,
    three: 0,
    five: 0,
  };

  generateBarChartData() {
    // for (int x = 1; x < 3; x++)
    // {
    //     y3 += IllustrationEntries.ElementAt(x).CashFlowEntry.Contribution;
    //     y3 += IllustrationEntries.ElementAt(x).CashFlowEntry.HealthAllocatedIncome;
    //     y3 *= (1 + IllustrationEntries.ElementAt(x).CashFlowEntry.ExpectedRor);
    // }

    // console.log(this.totalRemainingGap);

    //var num = Utils.formatToNumber(this.response.depositedToday).toFixed(0);

    this.cowValues.one = this.response.costOfWaitingToday ? Utils.formatToCurrency(this.response.costOfWaitingToday.toFixed(0)) : 0;
    this.cowValues.three = this.response.costOfWaitingThree ? Utils.formatToCurrency(this.response.costOfWaitingThree.toFixed(0)) : 0;
    this.cowValues.five = this.response.costOfWaitingFive ? Utils.formatToCurrency(this.response.costOfWaitingFive.toFixed(0)) : 0;
    
    this.barChartData = [
      {
        "name": "Today",
        "value": this.response.costOfWaitingToday
      },
      {
        "name": "3 Years",
        "value": this.response.costOfWaitingThree
      },
      {
        "name": "5 Years",
        "value": this.response.costOfWaitingFive
      }
    ]
  }

  clientHubRedirect(){
    this.router.navigate(['/clients/edit']);
  }

  handleSavingLTC() {

    const isMarried = this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? true : false;

    var Report = {
      ClientID: this.client.client.ID,
      AdvisorID: this.client.client.AdvisorID,
      CompanyCode: this.client.client.OrganizationID,
      ReportTypeID: 4
    }

    var client = this.client;

    var investmentItems = [];
    var currentAge = this.calculateAge(client.client.DOB);
    var currentYear = new Date().getFullYear();
    
    for (var item in this.fundingItems) {

      var contribution = {
        Description: this.fundingItems[item].fundingSource,
        Begins: this.fundingItems[item].startAge,
        StartAmount: this.fundingItems[item].annContribution,
        Ends: this.fundingItems[item].endAge,
        Cola: this.fundingItems[item].inflationRate,
      }

      investmentItems.push(contribution);
    }

    this.selfRegion = parseInt(client.clientProfile.ClientMetroArea || 0);
    // if(isMarried){
    //   this.spouseType = parseInt(client.clientProfile.SpouseMetroArea || 0);
    // }
    let spouseDOB = this.client.clientProfile.Spouses[0].dobStr ? this.client.clientProfile.Spouses[0].dobStr : (new Date(this.client.clientProfile.Spouses[0].dob) ? this.client.clientProfile.Spouses[0].dob : '');
    var ReportLTC = {
      investmentItems: JSON.stringify({ investmentItems }),
      FrmHasPartner: isMarried,
      FrmName0: client.client.FirstName + '/' + client.client.LastName,
      FrmName1: isMarried ? client.clientProfile.Spouses[0].firstName + '/' + client.clientProfile.Spouses[0].lastName : '',
      FrmGender0: client.client.GenderID,
      FrmCurrentAge0: this.calculateAge(client.client.DOB),
      FrmGender1: isMarried ? Number(client.clientProfile.Spouses[0].gender) : 0,
      FrmCurrentAge1: isMarried ? this.calculateAge(client.clientProfile.Spouses[0].dob) : 0,
      FrmLTCState0: client.clientProfile.UseNationalAverage ? '' : client.clientProfile.RetirementState,
      FrmHealth0: 0,
      FrmHealth1: 0,
      FrmLTCState1: isMarried ? (client.clientProfile.UseNationalAverage ? '' : this.client.clientProfile.Spouses[0].state) : '',

      /* FrmPhase1Rate: (this.p1Percent ? (Number(this.p1Percent.nativeElement.value)) : 6),
      FrmPhase1Periods: (this.p1EndAge ? Number(this.p1EndAge.nativeElement.value) - this.calculateAge(this.client.client.DOB) : Math.max(65 - Number(this.calculateAge(this.client.client.DOB)))),
      FrmPhase2Rate: (this.p2Percent ? (Number(this.p2Percent.nativeElement.value)) : 6),
      FrmPhase2Periods: (this.p2EndAge ? (Number(this.p2EndAge.nativeElement.value) - (Number(this.p1EndAge.nativeElement.value))) : 10),
      FrmPhase3Rate: (this.p3Percent ? (Number(this.p3Percent.nativeElement.value)) : 6), */
      FrmPhase1Rate: this.objAdjustRates ? (Number(this.objAdjustRates.rorOne)) : 6,
      FrmPhase1Periods: this.objAdjustRates ? Number(this.objAdjustRates.throughYearOne) : Math.max(65 - Number(this.calculateAge(this.client.client.DOB))),
      FrmPhase2Rate: this.objAdjustRates ? (Number(this.objAdjustRates.rorTwo)) : 6,
      FrmPhase2Periods: this.objAdjustRates ? (Number(this.objAdjustRates.throughYearTwo)) : 10,
      FrmPhase3Rate: this.objAdjustRates ? (Number(this.objAdjustRates.rorThree)) : 6,
      

      FrmLTCMonths0: this.selfPeriods,
      FrmLTCMonths1: this.spousePeriods,
      
      FrmPlanningAge0: this.client.clientProfile.LifeExpectancy,
      FrmPlanningAge1: isMarried ?  Number(this.client.clientProfile.Spouses[0].LifeExpectancy) : 0,

      FrmQType: this.client.clientProfile.HCT1D,
      FrmQTypeII: this.client.clientProfile.HCT2D,
      FrmQTobacco: this.client.clientProfile.HCT,
      FrmQCancer: this.client.clientProfile.HCC,
      FrmQHistory: this.client.clientProfile.HCFHDC,
      FrmQMS: this.client.clientProfile.HCMS,
      FrmQCardio: this.client.clientProfile.HCCD,
      FrmQHighCholesterol: this.client.clientProfile.HCHC,
      FrmQHBP: this.client.clientProfile.HCHBP,
      FrmQAlzheimer: this.client.clientProfile.HCALZ,
      FrmQParkinson: this.client.clientProfile.HCPARK,
      FrmQPTSD: this.client.clientProfile.HCPTSD,
      FrmQAmputation: this.client.clientProfile.HCAMP,
      FrmQObesity: this.client.clientProfile.HCOBS,
      FrmQDCW: this.client.clientProfile.HCDCW,

      SpouseFrmQType: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCT1D ? 1 : 0 : 0,
      SpouseFrmQTypeII: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCT2D ? 1 : 0 : 0,
      SpouseFrmQTobacco: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCT ? 1 : 0 : 0,
      SpouseFrmQCancer: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCC ? 1 : 0 : 0,
      SpouseFrmQMS: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCMS ? 1 : 0 : 0,
      SpouseFrmQCardio: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCCD ? 1 : 0 : 0,
      SpouseFrmQHighCholesterol: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCHC ? 1 : 0 : 0,
      SpouseFrmQHBP: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCHBP ? 1 : 0 : 0,
      SpouseFrmQAlzheimer: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCALZ ? 1 : 0 : 0,
      SpouseFrmQParkinson: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCPARK ? 1 : 0 : 0,
      SpouseFrmQDCW: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCDCW ? 1 : 0 : 0,
      SpouseFrmQPTSD: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCPTSD ? 1 : 0 : 0,
      SpouseFrmQAmputation: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCAMP ? 1 : 0 : 0,
      SpouseFrmQObesity: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCOBS ? 1 : 0 : 0,
      SpouseFrmQHistory: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCFHDC ? 1 : 0 : 0,

      MetroRegion0: this.selfRegion, // here
      MetroRegion1: this.spouseRegion,

      MetroRegionDesc0: this.getRegionDescription(this.client.clientProfile.RetirementState, this.selfRegion, true),
      MetroRegionDesc1: this.getRegionDescription(isMarried ? this.client.clientProfile.Spouses[0].state : '', this.spouseRegion, false),

      UseNationalAverage: this.client.clientProfile.UseNationalAverage ? 1 : 0,

      //InvestmentYears: this.annualEl ? Number(this.annualEl.nativeElement.value): 0,
      InvestmentYears: (this.investmentOption == 1) ? this.annualEl && this.annualEl.nativeElement ? this.annualEl.nativeElement.value : (this.annuallyWeeklyTtlYear < 10 ? 1 : 10) 
        : (this.investmentOption == 2) ? this.bodyCardSelectedIndexAnnually : this.bodyCardSelectedIndexWeekly,
      InvestmentOption: this.investmentOption,

      CareType: this.selfType,
      CareType1: this.spouseType,
      CareTypes: JSON.stringify(this.selfTypeList),
      CareTypes1: JSON.stringify(this.spouseTypeList),
      SpouseDOB: spouseDOB,
      SelfDOB: this.client.client.DOB
    }
    
    this.globalService.createReportLTC(Report, ReportLTC)
      .subscribe(
      resp => {
        this.snackBarService.add("Please wait while your long-term care report is being generated.", 0);
        //this.router.navigateByUrl('/reports/create?d=t');
        this.downloadReport(resp.ReportID, resp.AdvisorID, resp.ClientID, resp.CompanyCode, resp.ReportTypeID);
      },
      error => this.error = <any>error);

  }
  
  getRegionDescription(state, code, isClient) {
    let description = "";
    console.log('state', state);
    if (state != 'NA') {
      let region = isClient ? this.clientRegions : this.spouseRegions;
    
      region.forEach((row) => {
        if (row.MetroRegionCode == code && row.StateCode == state)
          description = row.MetroRegion;
      });
  
      description = description.length ? description : "State Average";
    }

    return description;
  }

  downloadReport(reportID, advisorID, clientID, orgID, reportTypeID) {
    this.loadingService.isLoading(true);
    var ReportFields = { reportID, advisorID, clientID, orgID, ReportTypeID: reportTypeID, token: localStorage.getItem("bearer") };
    //console.log("LTC_ReportFields", ReportFields);

    this.globalService.generateReport(ReportFields, this.client.client, ReportFields)
      .subscribe(
      resp => {
        this.loadingService.isLoading(false);
      },
      error => {
        this.error = <any>error;
        this.loadingService.isLoading(false);
      });
  }

  formatCurrency(val) {
    return Utils.formatToCurrency(Utils.formatToNumber(val));
  }

  public investmentOption: any = 1;

  onRateSelected(rate) {
    if (rate === 1)
      this.investmentOption = 1;
    else if (rate === 2)
      this.investmentOption = 2;
    else if (rate === 3)
      this.investmentOption = 3;

    this.getLTCData(this.client);
  }

  returnedAdjustStartInvestment(data){
    console.log('data', data);
    console.log('from funding year dropdown', data.selectedBalance);
    if(data.isWeekly){
      this.weeklyCost = data.selectedBalance;
      this.adjustedWeeklyCost = data.selectedBalance;
      this.bodyCardSelectedIndexWeekly = data.selectedDropDownIndex;
    } else {
      this.yearlyCost = data.selectedBalance;
      this.adjustedYearlyCost = data.selectedBalance;
      this.bodyCardSelectedIndexAnnually = data.selectedDropDownIndex;
    }
    // this.bodyCardSelectedIndex = data.selectedDropDownIndex;
  }

  getRegionVerbiage() {
    let verbiage = `Metro Region(${this.client.clientProfile && this.client.clientProfile.RetirementState ? this.client.clientProfile.RetirementState : "--"})`;
    return this.client.clientProfile.UseNationalAverage ? `National Average` : verbiage;
  }

  getRegionSpouseVerbiage() {
    let verbiage = `Metro Region(${this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].state ? this.client.clientProfile.Spouses[0].state : "--"})`;
    return this.client.clientProfile.UseNationalAverage ? `National Average` : verbiage;
  }

  textCheck() {
    if (this.fundingSource) {
      this.showFundingBorder = false;
    } else {
      this.showFundingBorder = true;
    }

    if ((this.annContribution) && (this.annContribution >= 100 && this.annContribution <= 1000000)) {
      this.showAnnContrBorder = false;
    } else {
      this.showAnnContrBorder = true;
    }

    if (this.startAge) {
      this.showStartAgeBorder = false;
    } else {
      this.showStartAgeBorder = true;
    }

    if (this.endAge) {
      this.showEndAgeBorder = false;
    } else {
      this.showEndAgeBorder = true;
    }

    if (this.inflationRate) {
      this.showInflationBorder = false;
    } else {
      this.showInflationBorder = true;
    }
    if (!this.fundingSource && !this.annContribution && !this.startAge && !this.endAge && !this.inflationRate) {
      this.showFundingBorder = false;
      this.showAnnContrBorder = false;
      this.showStartAgeBorder = false;
      this.showEndAgeBorder = false;
      this.showInflationBorder = false;
    }
  }

  fundingTableCount() {
    this.fundingItems;
    let count = this.fundingItems.length 
    if (count >= 1) {
      this.showTable = true;
    } else {
      this.showTable = false;      
    }
  }

  fundingSourceModal(modalName): void {
    const dialogRef = this.dialog.open(FundingSourceComponent, {
      width: '1000px',
      height: '700px',
      data: { client: this.client, data: this.response, modalName: modalName }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.fundingItems.push(result.data);
      console.log('here i am 02');
      this.fundingTableCount();

    });
  }

  formatName() {
    if (this.client) {
      return this.client.clientProfile && this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].firstName ?
        this.client.client.FirstName + ' and ' + this.client.clientProfile.Spouses[0].firstName + ' ' + this.client.client.LastName
        : this.client.client.FirstName + ' ' + this.client.client.LastName
    }
  }

  toggleDuration() {
    this.getLTCData(this.client);
  }

  selectInvestmentOption(option) {
    this.investmentOptionValue = option;
  }

  bodyCardSelection(scenario) {
    console.log('bodyCardSelection');
    console.log(scenario);
    this.selected.isoneTimeInvestmentSelect = false;
    this.selected.isannuallyRecurringInvestmentSelect = false;
    this.selected.isweeklyRecurringInvestmentSelect = false;
    if (scenario == 'isoneTimeInvestmentSelect') {
      this.selected.isoneTimeInvestmentSelect = true;
      // this.investmentDescription = "test"
      this.investmentOption = 1;
    }
    if (scenario == 'isannuallyRecurringInvestmentSelect') {
      // let bodyCardSelectedIndex = (this.bodyCardSelectedIndex ? this.bodyCardSelectedIndex : this.dropDownSelectedIndex).toString();
      let dropDownSelectedIndex = this.dropDownSelectedIndexAnnually ? this.dropDownSelectedIndexAnnually :(Number(this.annuallyWeeklyTtlYear) < 10 ? 1: 10);
      let bodyCardSelectedIndex = (this.bodyCardSelectedIndexAnnually? this.bodyCardSelectedIndexAnnually : dropDownSelectedIndex).toString();
      this.investmentDescription = "Annually for " + bodyCardSelectedIndex + " years"
      this.selected.isannuallyRecurringInvestmentSelect = true;
      this.investmentOption = 2;
    }
    if (scenario == 'isweeklyRecurringInvestmentSelect') {
      let dropDownSelectedIndex = this.dropDownSelectedIndexWeekly ? this.dropDownSelectedIndexWeekly :(Number(this.annuallyWeeklyTtlYear) < 10 ? 1: 10);
      let bodyCardSelectedIndex = (this.bodyCardSelectedIndexWeekly? this.bodyCardSelectedIndexWeekly : dropDownSelectedIndex).toString();
      this.investmentDescription = "Weekly for " + bodyCardSelectedIndex + " years"
      this.selected.isweeklyRecurringInvestmentSelect = true;
      this.investmentOption = 3;
    }

  }

  // formatDataLabel(value)
  // {
  //   return Utils.formatToCurrency(value);
  //   //return "$" + value
  // }

  investmentGrowthData;
  getInvestmentGrowthData(){
 
    //var test = this.response.IllustrationArray;
    //console.log('LTC Data Test', test);
    let clientCurrentAge = this.calculateAge(this.client.client.DOB);
    let isClientAlreadyRetired = this.client.clientProfile.RetirementAge <= clientCurrentAge ? true: false;
    let isSpouseAlreadyRetired = false;
    const isMarried = this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? true : false;
    console.log('this.client.clientProfile', this.client.clientProfile)
    console.log('isMarried', isMarried);

    if (isMarried) {
      let spouseAge = this.calculateAge(this.client.clientProfile.Spouses[0].dob);
      isSpouseAlreadyRetired = isMarried ? (this.client.clientProfile.Spouses[0].retirementAge <= spouseAge ? true: false): isSpouseAlreadyRetired;
    }
    if (isClientAlreadyRetired || isSpouseAlreadyRetired) {
      this.barVerticalStackedChartOption = {
        showXAxis: true,
        showYAxis: true,
        gradient: false,
        showLegend: false,
        showXAxisLabel: false,
   
        showYAxisLabel: false,
   
   
        roundEdges: false,
        colorScheme: {
          //domain: ['#3385C5', '#E58931', '#20a59f']
          // domain: ['#5270ad', '#487879', '#63a49e']
          // domain: ['#63a49e', '#5270ad','#487879']
          domain: ['#5270ad', '#487879','#63a49e']
        },
        autoScale: true
   
      };
      this.preRetirementColor = this.barVerticalStackedChartOption.colorScheme.domain[2];
      this.inRetirementColor = this.barVerticalStackedChartOption.colorScheme.domain[1];
      this.annulLTCColor = this.barVerticalStackedChartOption.colorScheme.domain[0];
    }
    console.log('this.response.IllustrationArra', this.response.IllustrationArray)
    this.investmentGrowthData = this.response.IllustrationArray;
  }
 
  //Risk Tolerance  
  isRiskModalDisplayed: boolean = false;
  handleRiskTolCheck(url) {
    //url === '/clients/edit/long-term-care/options/ltcrt'
    if (url === '/clients/edit/long-term-care/options/ltcrt' && !this.isRiskModalDisplayed) {
      //console.log('running RT');
      //this.reDirectModal('riskTolerance');
      this.isRiskModalDisplayed = true;
    }
  }

  getRiskTolPhaseAOrAn(phase): string {
    return ['Aggressive','Income & Growth', 'Income'].includes(phase) ? 'an' : 'a'
  }

  saveClientRiskTol(isAdvisoryAgreementSave: boolean = false){
    var body = {
      ClientID: localStorage.getItem('selectedClient'),
      LvlOfInvestExpID: this.objRiskTolerance.levelOfInvestment,
      LngthOfInvestID: this.objRiskTolerance.lengthOfInvestment,
      ToleranceOfRiskID: this.objRiskTolerance.toleranceOfRisk,
      NeedRedeemID: this.objRiskTolerance.isRedeemAccount,

      //below comes from the Advisor Agreement/Open Account modal object
      AccountType: (this.objRickToleranceAccountAgreement) ? this.objRickToleranceAccountAgreement.accountType : 0,
      HasSignedAdvisoryAgreement: (this.objRickToleranceAccountAgreement) ? this.objRickToleranceAccountAgreement.advisorAgreement : 0,//advisorAgreement
      HasSignedUpForManagedAccount: (this.objRickToleranceAccountAgreement) ? this.objRickToleranceAccountAgreement.wantsToOpenAnAccount : 0,//aggrement || wantsToOpenAnAccount
      SignedAdvisoryAgreementDate: (this.objRickToleranceAccountAgreement) ? this.objRickToleranceAccountAgreement.advisorAgreementSignDate : null //advisorAgreementSignDate
    };

    this.globalService.updateClientRiskTolerance(body)
    .subscribe(
      resp => {
        //boolean returned here
        console.log('client updated RT', resp);
        this.getPortfolioRecommendation();

        if(isAdvisoryAgreementSave){
          if(this.objRickToleranceAccountAgreement.notCandidateToOpenAccount){
            this.snackBarService.add("Unfortunately, you are not a candidate for HealthView Asset management. Based on your risk tolerance response, we suggest a portfolio of money market and CDs.", 0);            
          } else {
            this.snackBarService.add("Thank you! HealthView Asset management will be in touch shortly.", 0);
          }
        }
      });    
  }

    portfolioRecommendationObjectAge;
    getPortfolioRecommendation() {
    if(!this.globalService.featRiskTolerance){
      return;
    }

    if (this.globalService.featRiskTolerance && !this.hasRiskTolBeenRan) {
      let unfundeHealthCareCost = 0;
      unfundeHealthCareCost = this.currentRemainingTotalForRiskTolPort ? this.currentRemainingTotalForRiskTolPort: this.currentRemainingTotal;
      for(var item of this.fundingItems) {
  
        if (item.remainingUnfunded) {
          unfundeHealthCareCost += item.remainingUnfunded;
        }
      }
      let isClientRetiringFirst = this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? Number(this.client.clientProfile.RetirementAge - this.calculateAge(this.client.client.DOB)) <= Number(this.client.clientProfile.Spouses[0].retirementAge - this.calculateAge(this.client.clientProfile.Spouses[0].dob)) : true;
      let isClientRetired = this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ?(Number(this.client.clientProfile.RetirementAge - this.calculateAge(this.client.client.DOB)) < 0 ? true: false)  :false ;
      let isSpouseRetired = this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ?(Number(this.client.clientProfile.Spouses[0].retirementAge - this.calculateAge(this.client.clientProfile.Spouses[0].dob)) < 0 ? true: false)  :false ;
      let clientAge = '';
      let clientRetirementAge = '';

      if((isClientRetired && isSpouseRetired) || (!isClientRetired && !isSpouseRetired)) {
        clientAge = isClientRetiringFirst ? JSON.stringify(this.calculateAge(this.client.client.DOB)) : JSON.stringify(this.calculateAge(this.client.clientProfile.Spouses[0].dob));
        clientRetirementAge = isClientRetiringFirst ? JSON.stringify(this.client.clientProfile.RetirementAge) : this.client.clientProfile.Spouses[0].retirementAge;
      } else if (isClientRetired) {
        clientAge = JSON.stringify(this.calculateAge(this.client.clientProfile.Spouses[0].dob));
        clientRetirementAge = this.client.clientProfile.Spouses[0].retirementAge;
      } else {
        clientAge = JSON.stringify(this.calculateAge(this.client.client.DOB));
        clientRetirementAge = JSON.stringify(this.client.clientProfile.RetirementAge);
      }

      var riskTolerance = {
        ClientID: localStorage.getItem('selectedClient'),
        ClientAge: clientAge,
        ClientRetirementAge: clientRetirementAge,
        estimateLifeTimeCostInFuture: JSON.stringify(this.futureTotalCost),
        unfundedHealthCareCost: JSON.stringify(unfundeHealthCareCost),
        LevelOfInvestmentID: this.objRiskTolerance.levelOfInvestment,
        LengthOfInvestmentID: this.objRiskTolerance.lengthOfInvestment,
        ToleranceOfRiskID: this.objRiskTolerance.toleranceOfRisk,
        NeedRedeemID: this.objRiskTolerance.isRedeemAccount
      }

      console.log('risk obj: ', riskTolerance);

      this.globalService.getRiskTolerancePortfolio(riskTolerance).subscribe(
        resp => {
          console.log('resp for RT: ', resp);
          let clientRealAge = JSON.stringify(this.calculateAge(this.client.client.DOB));
          if (resp.PhaseOneRecommend) {
            this.portfolioRecommendationVisible = true;
          }

          if(!this.portfolioRecommendationObject){
            this.portfolioRecommendationObject = {
              year: String(isClientRetiringFirst ? this.getRetirementYear(this.client.clientProfile.RetirementAge, this.client.client.DOB) : this.getRetirementYear(this.client.clientProfile.Spouses[0].retirementAge, this.client.clientProfile.Spouses[0].dob)),
              phase1Portfolio: resp.PhaseOneRecommend,
              phase2Portfolio: resp.PhaseTwoRecommend,
              phase3Portfolio: resp.PhaseThreeRecommend,
              phase1Val: resp.PhaseOneROR,
              phase2Val: resp.PhaseTwoROR,
              phase3Val: resp.PhaseThreeROR,
              clientAge: clientAge,
              spouseAge: this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? `${this.calculateAge(this.client.clientProfile.Spouses[0].dob)}` : '0' ,
              clientRetirementAge: clientRetirementAge,
              spouseRetirementAge: this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? this.client.clientProfile.Spouses[0].retirementAge : '0' ,
              singleInvestment: (resp.SingleInvestment && resp.SingleInvestment != 0) ? Utils.formatToCurrency(resp.SingleInvestment) : (this.portfolioRecommendationObject) ? this.portfolioRecommendationObject.singleInvestment || 0 : this.totalRemainingGap,
              unfundedAmount: this.futureTotalCost ? String(Utils.formatToCurrency(this.futureTotalCost)): '$0',
              isMarried: this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? true: false,
              clientRealAge: clientRealAge,
              clientRealRetirementAge: this.client.clientProfile.RetirementAge,
              spouseFirstName: this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? this.client.clientProfile.Spouses[0].firstName: '',
              spouseLastName: this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? this.client.clientProfile.Spouses[0].lastName: '',
              ltcReport: this.ltcReport,
              user: this.user
            }
          }

          if(!this.objAdjustRates){
            this.objAdjustRates = {
              rorOne: Number(this.portfolioRecommendationObject.phase1Val),
              throughYearOne: this.getPhaseAgeDiff(1),
              rorTwo: Number(this.portfolioRecommendationObject.phase2Val),
              throughYearTwo: this.getPhaseAgeDiff(2),
              rorThree: Number(this.portfolioRecommendationObject.phase3Val)
            }
          }

          this.totalRemainingGap = this.portfolioRecommendationObject.singleInvestment;

          if (Number(clientAge) >= Number(this.client.clientProfile.RetirementAge)) {
            this.isAlreadyRetired = true;
          } else {
            this.isAlreadyRetired = false;
          }

          let age;
          if (this.portfolioRecommendationObject.isMarried && !this.isHCIllustration) {
            this.portfolioRecommendationObjectAge = age = isClientRetiringFirst ? (Math.max(this.portfolioRecommendationObject.clientAge, this.portfolioRecommendationObject.clientRetirementAge)  + "/" + Math.max(this.portfolioRecommendationObject.spouseAge && this.portfolioRecommendationObject.spouseRetirementAge)) 
              : (Math.max(this.portfolioRecommendationObject.spouseAge && this.portfolioRecommendationObject.spouseRetirementAge) + "/" + Math.max(this.portfolioRecommendationObject.clientAge, this.portfolioRecommendationObject.clientRetirementAge));
          } else {
            this.portfolioRecommendationObjectAge = age = Math.max(this.portfolioRecommendationObject.clientAge, this.portfolioRecommendationObject.clientRetirementAge);
          }
          if (this.isHCIllustration) {
            this.rorPhaseOneYear = this.isRetired ? "Through Retirement" : "Through " + this.portfolioRecommendationObject.year + " (Age "+ age + ")"
          } else {
            this.rorPhaseOneYear = this.isRetired ? "Distribution Through Retirement" : "Through " + this.portfolioRecommendationObject.year + " (Age "+ age + ")"
          }

          this.hasRiskTolBeenRan = true;
          this.setRiskTolRates(this.portfolioRecommendationObject.phase1Portfolio);
          //this.getHCData(this.client, this.partnerActive, true);
          //this.getHCData(this.client, this.partnerActive, true);
          this.getLTCData(this.client, true);
        },
        error => {
          this.error = <any>error;
        });
    }
  }

  getPhaseDiff(phase) {
    const clientAge = Number(this.calculateAge(this.client.client.DOB));
    const clientRetirementAge = Number(this.client.clientProfile.RetirementAge);
    const clientLE = Number(this.client.clientProfile.LifeExpectancy);
    const spouseAge = Number(this.calculateAge(this.client.clientProfile.Spouses[0].dob)) || 0;
    const spouseRetirementAge = Number(this.client.clientProfile.Spouses[0].retirementAge) || 0;
    const spouseLE = Number(this.client.clientProfile.Spouses[0].LifeExpectancy) || 0;

    if (spouseAge && spouseRetirementAge) {
      if (phase == 1)
        return Math.min(Math.max(0, clientRetirementAge - clientAge), Math.max(0, spouseRetirementAge - spouseAge));
      if (phase == 2)
        return Math.min(Math.max(0, clientLE - clientRetirementAge), Math.max(0, spouseLE - spouseRetirementAge));
    } else {
      if (phase == 1)
        return Math.max(0, clientRetirementAge - clientAge);
      if (phase == 2)
        return Math.max(0, clientLE - clientRetirementAge);
    }
  }

  getPhaseAgeDiffLTC(phase) {
    let clientYearsToRetire = 0;
    let spouseYearsToRetire = 0;
    let clientRetirementYears = 0;
    let spouseRetirementYears = 0;
    
    //clientYearsToRetire = Math.max(0, Number(this.portfolioRecommendationObject.clientRetirementAge)) - Number(this.portfolioRecommendationObject.clientAge);
    //spouseYearsToRetire = Math.max(0, Number(this.portfolioRecommendationObject.spouseRetirementAge)) - Number(this.portfolioRecommendationObject.spouseAge);
    //let year = this.currentYear + (Number(this.portfolioRecommendationObject.spouseAge) > 0 ? Math.min(clientYearsToRetire, spouseYearsToRetire) : Math.max(0, clientYearsToRetire));

    if (phase === 1) {
      clientYearsToRetire = Math.max(0, Number(this.portfolioRecommendationObject.clientRetirementAge)) - Number(this.portfolioRecommendationObject.clientAge);
      spouseYearsToRetire = Math.max(0, Number(this.portfolioRecommendationObject.spouseRetirementAge)) - Number(this.portfolioRecommendationObject.spouseAge);
      return (Number(this.portfolioRecommendationObject.spouseAge) > 0 ? Math.min(clientYearsToRetire, spouseYearsToRetire) : Math.max(0, clientYearsToRetire));
    } else {
      clientRetirementYears = Math.max(0, Number(this.client.clientProfile.LifeExpectancy)) - Number(this.portfolioRecommendationObject.clientRetirementAge);
      spouseRetirementYears = Math.max(0, Number(this.client.clientProfile.Spouses[0].LifeExpectancy)) - Number(this.portfolioRecommendationObject.spouseRetirementAge);
      return (Number(this.portfolioRecommendationObject.spouseAge) > 0 ? Math.min(clientRetirementYears, spouseRetirementYears) : Math.max(0, clientRetirementYears));
    }    
  }

  getPhaseAgeDiff(phase) {
    let clientYearsToRetire = 0;
    let spouseYearsToRetire = 0;
    let clientRetirementYears = 0;
    let spouseRetirementYears = 0;
    
    //clientYearsToRetire = Math.max(0, Number(this.portfolioRecommendationObject.clientRetirementAge)) - Number(this.portfolioRecommendationObject.clientAge);
    //spouseYearsToRetire = Math.max(0, Number(this.portfolioRecommendationObject.spouseRetirementAge)) - Number(this.portfolioRecommendationObject.spouseAge);
    //let year = this.currentYear + (Number(this.portfolioRecommendationObject.spouseAge) > 0 ? Math.min(clientYearsToRetire, spouseYearsToRetire) : Math.max(0, clientYearsToRetire));
    clientYearsToRetire = Math.max(0, Number(this.portfolioRecommendationObject.clientRetirementAge)) - Number(this.portfolioRecommendationObject.clientAge);
    spouseYearsToRetire = Math.max(0, Number(this.portfolioRecommendationObject.spouseRetirementAge)) - Number(this.portfolioRecommendationObject.spouseAge);
    let year = this.currentYear + (Number(this.portfolioRecommendationObject.spouseAge) > 0 ? Math.min(clientYearsToRetire, spouseYearsToRetire) : Math.max(0, clientYearsToRetire));

    if (phase === 1) {
      //clientYearsToRetire = Math.max(0, Number(this.portfolioRecommendationObject.clientRetirementAge)) - Number(this.portfolioRecommendationObject.clientAge);
      //spouseYearsToRetire = Math.max(0, Number(this.portfolioRecommendationObject.spouseRetirementAge)) - Number(this.portfolioRecommendationObject.spouseAge);
      //return (Number(this.portfolioRecommendationObject.spouseAge) > 0 ? Math.min(clientYearsToRetire, spouseYearsToRetire) : Math.max(0, clientYearsToRetire));
      return year;
    } else {
      //clientRetirementYears = Math.max(0, Number(this.client.clientProfile.LifeExpectancy)) - Number(this.portfolioRecommendationObject.clientRetirementAge);
      //spouseRetirementYears = Math.max(0, Number(this.client.clientProfile.Spouses[0].LifeExpectancy)) - Number(this.portfolioRecommendationObject.spouseRetirementAge);
      //return (Number(this.portfolioRecommendationObject.spouseAge) > 0 ? Math.min(clientRetirementYears, spouseRetirementYears) : Math.max(0, clientRetirementYears));
      clientRetirementYears = Math.max(0, Number(this.client.clientProfile.LifeExpectancy)) - Number(this.portfolioRecommendationObject.clientRetirementAge);
      console.log('return of phase 2', this.portfolioRecommendationObject);
      spouseRetirementYears = Math.max(0, Number(this.client.clientProfile.Spouses[0].LifeExpectancy)) - Number(this.portfolioRecommendationObject.spouseRetirementAge);
      return year + (Number(this.portfolioRecommendationObject.spouseAge) > 0 ? Math.min(clientRetirementYears, spouseRetirementYears) : Math.max(0, clientRetirementYears));
    }    
  }

  handleSavingRiskToleranceLTC() {
    var Report = {
      ClientID: this.client.client.ID,
      AdvisorID: this.client.client.AdvisorID,
      CompanyCode: this.client.client.OrganizationID,
      ReportTypeID: 7,
    }

    const isMarried = this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? true : false;

    var client = this.client;

    var investmentItems = [];
    var currentAge = this.calculateAge(client.client.DOB);
    var currentYear = new Date().getFullYear();
    
    for (var item in this.fundingItems) {

      var contribution = {
        Description: this.fundingItems[item].fundingSource,
        Begins: this.fundingItems[item].startAge,
        StartAmount: this.fundingItems[item].annContribution,
        Ends: this.fundingItems[item].endAge,
        Cola: this.fundingItems[item].inflationRate,
      }

      investmentItems.push(contribution);
    }

    this.selfRegion = parseInt(client.clientProfile.ClientMetroArea || 0);
    // if(isMarried){
    //   this.spouseType = parseInt(client.clientProfile.SpouseMetroArea || 0);
    // }
    let spouseDOB = this.client.clientProfile.Spouses[0].dobStr ? this.client.clientProfile.Spouses[0].dobStr : (new Date(this.client.clientProfile.Spouses[0].dob) ? this.client.clientProfile.Spouses[0].dob : '');
    var ReportLTC = {
      investmentItems: JSON.stringify({ investmentItems }),
      FrmHasPartner: isMarried,
      FrmName0: client.client.FirstName + '/' + client.client.LastName,
      FrmName1: isMarried ? client.clientProfile.Spouses[0].firstName + '/' + client.clientProfile.Spouses[0].lastName : '',
      FrmGender0: client.client.GenderID,
      FrmCurrentAge0: this.calculateAge(client.client.DOB),
      FrmGender1: isMarried ? Number(client.clientProfile.Spouses[0].gender) : 0,
      FrmCurrentAge1: isMarried ? this.calculateAge(client.clientProfile.Spouses[0].dob) : 0,
      FrmLTCState0: client.clientProfile.UseNationalAverage ? '' : client.clientProfile.RetirementState,
      FrmHealth0: 0,
      FrmHealth1: 0,
      FrmLTCState1: isMarried ? (client.clientProfile.UseNationalAverage ? '' : this.client.clientProfile.Spouses[0].state) : '',

      /* FrmPhase1Rate: (this.p1Percent ? (Number(this.p1Percent.nativeElement.value)) : 6),
      FrmPhase1Periods: (this.p1EndAge ? Number(this.p1EndAge.nativeElement.value) - this.calculateAge(this.client.client.DOB) : Math.max(65 - Number(this.calculateAge(this.client.client.DOB)))),
      FrmPhase2Rate: (this.p2Percent ? (Number(this.p2Percent.nativeElement.value)) : 6),
      FrmPhase2Periods: (this.p2EndAge ? (Number(this.p2EndAge.nativeElement.value) - (Number(this.p1EndAge.nativeElement.value))) : 10),
      FrmPhase3Rate: (this.p3Percent ? (Number(this.p3Percent.nativeElement.value)) : 6), */
      FrmPhase1Rate: this.objAdjustRates ? (Number(this.objAdjustRates.rorOne)) : 6,
      FrmPhase1Periods: this.objAdjustRates ? Number(this.objAdjustRates.throughYearOne) : Math.max(65 - Number(this.calculateAge(this.client.client.DOB))),
      FrmPhase2Rate: this.objAdjustRates ? (Number(this.objAdjustRates.rorTwo)) : 6,
      FrmPhase2Periods: this.objAdjustRates ? (Number(this.objAdjustRates.throughYearTwo)) : 10,
      FrmPhase3Rate: this.objAdjustRates ? (Number(this.objAdjustRates.rorThree)) : 6,
      

      FrmLTCMonths0: this.selfPeriods,
      FrmLTCMonths1: this.spousePeriods,
      
      FrmPlanningAge0: this.client.clientProfile.LifeExpectancy,
      FrmPlanningAge1: isMarried ?  Number(this.client.clientProfile.Spouses[0].LifeExpectancy) : 0,

      FrmQType: this.client.clientProfile.HCT1D,
      FrmQTypeII: this.client.clientProfile.HCT2D,
      FrmQTobacco: this.client.clientProfile.HCT,
      FrmQCancer: this.client.clientProfile.HCC,
      FrmQHistory: this.client.clientProfile.HCFHDC,
      FrmQMS: this.client.clientProfile.HCMS,
      FrmQCardio: this.client.clientProfile.HCCD,
      FrmQHighCholesterol: this.client.clientProfile.HCHC,
      FrmQHBP: this.client.clientProfile.HCHBP,
      FrmQAlzheimer: this.client.clientProfile.HCALZ,
      FrmQParkinson: this.client.clientProfile.HCPARK,
      FrmQPTSD: this.client.clientProfile.HCPTSD,
      FrmQAmputation: this.client.clientProfile.HCAMP,
      FrmQObesity: this.client.clientProfile.HCOBS,
      FrmQDCW: this.client.clientProfile.HCDCW,

      SpouseFrmQType: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCT1D ? 1 : 0 : 0,
      SpouseFrmQTypeII: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCT2D ? 1 : 0 : 0,
      SpouseFrmQTobacco: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCT ? 1 : 0 : 0,
      SpouseFrmQCancer: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCC ? 1 : 0 : 0,
      SpouseFrmQMS: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCMS ? 1 : 0 : 0,
      SpouseFrmQCardio: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCCD ? 1 : 0 : 0,
      SpouseFrmQHighCholesterol: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCHC ? 1 : 0 : 0,
      SpouseFrmQHBP: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCHBP ? 1 : 0 : 0,
      SpouseFrmQAlzheimer: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCALZ ? 1 : 0 : 0,
      SpouseFrmQParkinson: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCPARK ? 1 : 0 : 0,
      SpouseFrmQDCW: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCDCW ? 1 : 0 : 0,
      SpouseFrmQPTSD: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCPTSD ? 1 : 0 : 0,
      SpouseFrmQAmputation: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCAMP ? 1 : 0 : 0,
      SpouseFrmQObesity: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCOBS ? 1 : 0 : 0,
      SpouseFrmQHistory: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCFHDC ? 1 : 0 : 0,

      MetroRegion0: this.selfRegion, // here
      MetroRegion1: this.spouseRegion,

      MetroRegionDesc0: this.getRegionDescription(this.client.clientProfile.RetirementState, this.selfRegion, true),
      MetroRegionDesc1: this.getRegionDescription(isMarried ? this.client.clientProfile.Spouses[0].state : '', this.spouseRegion, false),

      UseNationalAverage: this.client.clientProfile.UseNationalAverage ? 1 : 0,

      //InvestmentYears: this.annualEl ? Number(this.annualEl.nativeElement.value): 0,
      InvestmentYears: (this.investmentOption == 1) ? this.annualEl && this.annualEl.nativeElement ? this.annualEl.nativeElement.value : (this.annuallyWeeklyTtlYear < 10 ? 1 : 10) 
        : (this.investmentOption == 2) ? this.bodyCardSelectedIndexAnnually : this.bodyCardSelectedIndexWeekly,
      InvestmentOption: this.investmentOption,

      CareType: this.selfType,
      CareType1: this.spouseType,
      CareTypes: JSON.stringify(this.selfTypeList),
      CareTypes1: JSON.stringify(this.spouseTypeList),
      SpouseDOB: spouseDOB,
      SelfDOB: this.client.client.DOB
    }

    //HACK: trick object to allow new fields to be added...
    //var stringifiedReportLTC = JSON.stringify(ReportLTC);
    //JSON.parse(stringifiedReportLTC);

    ReportLTC.FrmPhase1Periods = ((this.objAdjustRates) ? this.objAdjustRates.throughYearOne - this.currentYear : this.getPhaseAgeDiffLTC(1));
    ReportLTC.FrmPhase1Rate = this.portfolioRecommendationObject.phase1Val || 0;
    ReportLTC.FrmPhase2Periods = ((this.objAdjustRates) ? this.objAdjustRates.throughYearTwo - this.objAdjustRates.throughYearOne : this.getPhaseAgeDiffLTC(2));
    ReportLTC.FrmPhase2Rate = this.isRetired ? this.portfolioRecommendationObject.phase1Val || 0: this.portfolioRecommendationObject.phase2Val || 0;
    //ReportLTC.FrmPhase3Rate = this.isRetired ? this.portfolioRecommendationObject.phase1Val || 0: this.portfolioRecommendationObject.phase2Val || 0;

    //Values.ReportHC.FinancialObjectiveID = this.getNumber(this.riskToleranceQuestionnaire.value.financialObjective) || 0;
    var ReportLTCAdj = { ...ReportLTC, 
      LevelOfInvestmentID: this.objRiskTolerance.levelOfInvestment || 0,
      LengthOfInvestmentID: this.objRiskTolerance.lengthOfInvestment || 0,
      ToleranceOfRiskID: this.objRiskTolerance.toleranceOfRisk || 0,
      NeedRedeemID: this.objRiskTolerance.isRedeemAccount || 0
    };
    
   /*  ReportLTCAdj.LevelOfInvestmentID = this.objRiskTolerance.levelOfInvestment || 0;//getNumber(Values.RiskTol.levelOfInvestment) || 0;
    ReportLTCAdj.LengthOfInvestmentID = this.objRiskTolerance.lengthOfInvestment || 0;//this.getNumber(Values.RiskTol.lengthOfInvestment) || 0;
    ReportLTCAdj.ToleranceOfRiskID = this.objRiskTolerance.toleranceOfRisk || 0;//this.getNumber(Values.RiskTol.toleranceOfRisk) || 0;
    ReportLTCAdj.NeedRedeemID = this.objRiskTolerance.isRedeemAccount || 0;//this.getNumber(Values.RiskTol.isRedeemAccount) || 0;
 */
    this.globalService.createReportLTC(Report, ReportLTCAdj)
    .subscribe(
      resp => {
        this.snackBarService.add("Please wait while your risk tolerance long-term care report is being generated.", 0);
        
        this.downloadReport(resp.ReportID, resp.AdvisorID, resp.ClientID, resp.CompanyCode, resp.ReportTypeID);
      },
        error => this.error = <any>error);
  }
  
  setRiskTolRates(phase) {
    console.log('phase', phase);
    if (phase == "Conservative Income" || phase == "Stable Value" || phase == null || phase == "")
    {
        this.equitiesLargeCap = 5;
        this.equitiesMidCap = 2;
        this.equitiesSmallCap = 0;
        this.equitiesInternational = 3;
        this.equitiesReturn = 10;
        this.fixedGovBonds = 60;
        this.fixedCorpBonds = 10;
        this.fixedReturn = 70;
        this.cashMoneyMarket = 20;
        this.cashMoneyMarketReturn = 20;
    }
    else if (phase == "Income")
    {
      this.equitiesLargeCap = 10;
      this.equitiesMidCap = 5;
      this.equitiesSmallCap = 0;
      this.equitiesInternational = 5;
      this.equitiesReturn = 20;
      this.fixedGovBonds = 50;
      this.fixedCorpBonds = 25;
      this.fixedReturn = 75;
      this.cashMoneyMarket = 5;
      this.cashMoneyMarketReturn = 5;
    }
    else if (phase == "Growth & Income")
    {
      this.equitiesLargeCap = 20;
      this.equitiesMidCap = 15;
      this.equitiesSmallCap = 10;
      this.equitiesInternational = 15;
      this.equitiesReturn = 60;
      this.fixedGovBonds = 20;
      this.fixedCorpBonds = 18;
      this.fixedReturn = 38;
      this.cashMoneyMarket = 2;
      this.cashMoneyMarketReturn = 2;
    }
    else if (phase == "Growth")
    {
      this.equitiesLargeCap = 22;
      this.equitiesMidCap = 20;
      this.equitiesSmallCap = 18;
      this.equitiesInternational = 20;
      this.equitiesReturn = 80;
      this.fixedGovBonds = 9;
      this.fixedCorpBonds = 10;
      this.fixedReturn = 19;
      this.cashMoneyMarket = 1;
      this.cashMoneyMarketReturn = 1;
    }
    else if (phase == "Income & Growth")
    {
      this.equitiesLargeCap = 15;
      this.equitiesMidCap = 10;
      this.equitiesSmallCap = 5;
      this.equitiesInternational = 10;
      this.equitiesReturn = 40;
      this.fixedGovBonds = 32;
      this.fixedCorpBonds = 25;
      this.fixedReturn = 57;
      this.cashMoneyMarket = 3;
      this.cashMoneyMarketReturn = 3;
    }
    else if (phase == "Aggressive")
    {
      this.equitiesLargeCap = 25;
      this.equitiesMidCap = 23;
      this.equitiesSmallCap = 20;
      this.equitiesInternational = 22;
      this.equitiesReturn = 90;
      this.fixedGovBonds = 4;
      this.fixedCorpBonds = 5;
      this.fixedReturn = 9;
      this.cashMoneyMarket = 1;
      this.cashMoneyMarketReturn = 1;
    }
  }  
}

